// extracted by mini-css-extract-plugin
export default {"brandText":"Navbar_brandText__OceX1"};